import {Col, Row, Image} from 'antd';
import React, {useEffect, useRef, useState} from 'react';
import './index.css'
import {useSelector} from 'react-redux';
import CreateChatApp from '../../../comm/createChat'
import {getHistoryMessages, hyperChat} from "../../../api/other";
import ErrorCorrectionAnswer from "./errorCorrectionAnswer";


const ErrorCorrectionApp = (props) => {
    const {sendTxt, setSendTxt, clearContent, setClearContent, setHomePageIndex,themeVlue,homePageIndex} = props
    const {size} = useSelector(state => state.fontSizeChange)
    const [pageList, setPageList] = useState([])
    const {userInfo, allContextMeta} = useSelector(state => state.user)
    var correcting_meta = null;
    if (userInfo && allContextMeta) {
        correcting_meta = allContextMeta.correcting_meta
    }
    const sizeStyle = {
        fontSize: size === '小' ? '15px' : (size === '中' ? '18px' : '22px')
    }
    const [viewType,setViewType] = useState('instant')
    useEffect(() => {
        if (sendTxt) {
            let list = pageList
            list.push({
                user_content: sendTxt.user_content
            })
            setViewType('smooth')
            setPageList([...list])
            setTimeout(() => {
                hyperChat(sendTxt).then(res => {
                    setSendTxt(null)
                    list[list.length - 1]['responder_content'] = res
                    setPageList([...list])
                })
            }, 500)
        }
    }, [sendTxt])
    useEffect(() => {
        handleScrollContainer()
    }, [pageList])
    var isReload = false
    useEffect(() => {
        if (!isReload && clearContent) {
            isReload = true
            if(correcting_meta) getHisList()
            setTimeout(() => {
                isReload = false
                setClearContent(false)
            }, 1000)
        }
    }, [clearContent])
    useEffect(() => {
        if (!isReload) {
            isReload = true
            if(correcting_meta) getHisList()
            setTimeout(() => {
                isReload = false
            }, 1000)
        }
    }, [homePageIndex])
    const handleScrollContainer = () => {
        chatEndRef.current?.scrollIntoView({behavior: viewType})
    }
    //获取历史记录
    const getHisList = (n) => {
        getHistoryMessages({context_id: correcting_meta?.context_id}).then(res => {
            if (res.code === 200) {
                setViewType('instant')
                setPageList(res.data)
            }
        })
    }
    const chatEndRef = useRef(null);
    const processListFormat = (v) => {
        let str = "";
        v.map(res => {
            if (res.includes('-')) {
                str += "<span>" + res.replace('-', '') + "</span>"
            } else if (res.includes('+')) {
                str += "<font>" + res.replace('+', '') + "</font>"
            } else {
                str += res
            }
        })
        return str
    }
    return (
        <div className='bg-e'>
            <div className={`bgWrap-e ${themeVlue==='default'?'':'drak'}`} id={'scrollable-element'}>
                {
                    pageList && pageList.length > 0 ?
                        pageList.map(res => {
                            return (
                                <div>
                                    {res?.user_content ?
                                        <div className="question">
                                            <Row>
                                                <Col span={2}> </Col>
                                                <Col span={20} className="questionInfo" style={sizeStyle}>
                                                    <span style={{
                                                        whiteSpace: 'pre-wrap',
                                                        wordWrap: 'break-word'
                                                    }}>{res.user_content[0].text}</span>
                                                </Col>
                                                <Col className='headPortrait' span={2}>
                                                    <Image preview={false} src={userInfo?.avatar} width={35}/>
                                                </Col>
                                            </Row>
                                        </div> : ''}
                                    {
                                        res?.responder_content && res?.responder_content.length > 0 ?
                                            <Row>
                                                <Col span={2} className="answerHeadPortrait">
                                                    <Image preview={false}
                                                           src={correcting_meta.responder_avatar?correcting_meta.responder_avatar:require('../../../assets/comm/ai-chat-t-head.png')}
                                                           width={35} height={35} style={{borderRadius:'50%'}}/>
                                                </Col>
                                                <Col span={20}>
                                                    <ErrorCorrectionAnswer answer={res}></ErrorCorrectionAnswer>
                                                </Col>
                                                <Col span={2}> </Col>
                                            </Row>
                                            : ''
                                    }
                                    <CreateChatApp addParam={res} originalScenario={'correcting'}
                                                   setHomePageIndex={setHomePageIndex}/>
                                </div>
                            )
                        })
                        : ''
                }
                <div ref={chatEndRef}/>
            </div>

        </div>
    )
};
export default ErrorCorrectionApp;
